import React, { useState } from "react";
import { Box, Flex, SystemProps, Icon, Text } from "@storyofams/react-ui";
import { useMeasure } from "react-use";
import { Minus, Plus } from "~components/common/Icons";
import { NhAccordion } from "~components/common/Story/NhComponents/NhAccordion";

interface AccordionProps extends SystemProps {
  faq: {
    answer_text: { text: string };
    question_text: { text: string };
  }[];
}

export const FAQ = ({ faq }: AccordionProps) => {
  if (!faq || !!!faq.length) return null;
  return (
    <Box mt={[0, "48px"]}>
      <Text
        display={["none", "block"]}
        fontFamily={"DINPro"}
        fontWeight={700}
        fontSize={"24px"}
        mb={[0, 2]}
      >
        {"FAQ"}
      </Text>
      <Box maxWidth={["none", "880px"]} width="100%" my={["2px", "30px"]}>
        {faq.map(({ answer_text, question_text }, i) => (
          <NhAccordion
            isFAQ
            isOpen={!i}
            title={question_text.text}
            key={question_text.text}
          >
            <Text lineHeight={"22.4px"} color="#1D1D1BCC">
              {answer_text.text}
            </Text>
          </NhAccordion>
        ))}
      </Box>
    </Box>
  );
};
